import React from "react";
import _ from "lodash";
import { FiEdit } from "react-icons/fi";
import AutoPilotConfigRadio from "./AutoPilotConfigRadio";
import ConfigValueReadonly from "./ConfigValueReadonly";

class ConfigValueControl extends React.PureComponent {
  constructor(props) {
    super(props);

    const isUseDefault = _.isUndefined(props.configValue);

    this.state = {
      isUseDefault,
      newValue: props.configValue,

      newRelatedValue: props.relatedValue,
      relatedUseDefault: _.map(props.relatedValue, (v) => _.isUndefined(v)),

      // TODO
      hasError: false,
    };

    this.handleIsUseDefaultChanged = this.handleIsUseDefaultChanged.bind(this);
    this.handleNewValueChanged = this.handleNewValueChanged.bind(this);
    this.handleRelatedUseDefaultChanged =
      this.handleRelatedUseDefaultChanged.bind(this);
    this.handleRelatedNewValueChanged =
      this.handleRelatedNewValueChanged.bind(this);
    this.handleApplyClicked = this.handleApplyClicked.bind(this);
    this.handleCancelClicked = this.handleCancelClicked.bind(this);
    this.handleHasError = this.handleHasError.bind(this);
  }

  handleHasError(hasError) {
    this.setState({ hasError });
  }

  handleIsUseDefaultChanged(isUseDefault) {
    const stateData = {};
    if (isUseDefault) {
      stateData.relatedUseDefault = _.map(
        this.state.relatedUseDefault,
        () => true
      );
      stateData.hasError = false;
    }
    this.setState({ isUseDefault, ...stateData });
  }

  handleNewValueChanged(value) {
    this.setState({ newValue: value });
  }

  handleRelatedUseDefaultChanged(index, isUseDefault) {
    const relatedUseDefault = [...this.state.relatedUseDefault];
    relatedUseDefault[index] = isUseDefault;
    this.setState({ relatedUseDefault });
  }

  handleRelatedNewValueChanged(index, newValue) {
    const newRelatedValue = [...this.state.newRelatedValue];
    newRelatedValue[index] = newValue;
    this.setState({ newRelatedValue });
  }

  handleCancelClicked() {
    const isUseDefault = _.isUndefined(this.props.configValue);
    this.setState({
      hasError: false,
      isUseDefault,
      newValue: this.props.configValue,
    });

    this.props.handleCancelEditMode();
  }

  handleApplyClicked(event) {
    event.preventDefault();
    if (this.state.hasError) {
      return;
    }

    const { isUseDefault, newValue, newRelatedValue, relatedUseDefault } =
      this.state;
    const { relatedSchema, valueSchema } = this.props;
    let value = newValue;

    const {
      valueType,
      section,

      // unit,
      prefix,
      key,
    } = valueSchema;

    switch (valueType) {
      case "integer":
      case "integer_enum": {
        value = _.parseInt(value);
        break;
      }

      case "float": {
        value = _.floor(value, 2);
        break;
      }

      case "boolean": {
        if (typeof newValue === "string") {
          value = newValue === "true" ? true : false;
        }
        break;
      }

      case "array_integer": {
        value = _.map(value, _.parseInt);
        break;
      }

      case "array_float": {
        value = _.map(value, parseFloat);
        break;
      }

      // "string_enum"
      default: {
      }
    }

    this.props.handleApplyChanges({
      configKey: key,
      isUseDefault,
      newValue: value,
      prefix,
      section,
      relatedConfig: _.map(relatedSchema, (s, index) => {
        return {
          ...s,
          newValue: newRelatedValue[index],
          isUseDefault: relatedUseDefault[index],
        };
      }),
    });
  }

  render() {
    const {
      unitId,
      networkId,
      configValue,
      valueSchema,
      relatedValue,
      relatedSchema,
      currentEditingKey,
      handleStartEditMode,
    } = this.props;

    const { valueType, defaultValue, unit } = valueSchema;
    const configKey = valueSchema.key;

    const { isUseDefault, hasError } = this.state;

    const hasConfigValue = !isUseDefault;
    const isEditingCurrentConfigValue = configKey === currentEditingKey;

    return (
      <>
        {isEditingCurrentConfigValue ? (
          <div>
            <form onSubmit={this.handleApplyClicked}>
              <div className="flex px-4">
                <div className="w-full">
                  <AutoPilotConfigRadio
                    networkId={networkId}
                    unitId={unitId}
                    configKey={configKey}
                    defaultValue={defaultValue}
                    unit={unit}
                    configValue={configValue}
                    valueSchema={valueSchema}
                    relatedSchema={relatedSchema}
                    relatedValue={relatedValue}
                    valueType={valueType}
                    isUseDefault={isUseDefault}
                    handleIsUseDefaultChanged={this.handleIsUseDefaultChanged}
                    handleNewValueChanged={this.handleNewValueChanged}
                    handleRelatedUseDefaultChanged={
                      this.handleRelatedUseDefaultChanged
                    }
                    handleRelatedNewValueChanged={
                      this.handleRelatedNewValueChanged
                    }
                    handleHasError={this.handleHasError}
                  ></AutoPilotConfigRadio>
                </div>
              </div>

              <div className="mt-8 flex items-center pl-4 text-sm">
                <button
                  type="submit"
                  disabled={hasError}
                  className={`${
                    hasError
                      ? "cursor-not-allowed bg-gray-600"
                      : "bg-blue-500 hover:bg-blue-700"
                  } rounded shadow px-8 py-1 font-semibold text-white`}
                >
                  Apply changes
                </button>

                <button
                  type="button"
                  className="px-8 py-1 font-semibold text-blue-500"
                  onClick={this.handleCancelClicked}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div>
            <div className="flex px-4">
              <div className="flex w-3/4 justify-between">
                <div className="w-full px-2">
                  {hasConfigValue ? (
                    <div>
                      {/* BODY */}
                      <div className="font-semibold text-blue-600">
                        <ConfigValueReadonly
                          valueType={valueType}
                          configValue={configValue}
                          valueSchema={valueSchema}
                          relatedValue={relatedValue}
                        ></ConfigValueReadonly>
                      </div>
                      {/* FOOT */}
                      <div className="text-sm text-gray-600">{unit}</div>
                    </div>
                  ) : (
                    <div>
                      {/* BODY */}
                      <div className="font-semibold text-gray-600">
                        <ConfigValueReadonly
                          valueType={valueType}
                          configValue={defaultValue}
                        ></ConfigValueReadonly>
                      </div>
                      {/* FOOT */}
                      <div className="text-sm text-gray-600">{unit}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className="w-1/4 text-right">
                <button
                  type="button"
                  disabled={!!currentEditingKey}
                  className={`rounded shadow p-4 ${
                    !!currentEditingKey
                      ? "cursor-not-allowed bg-gray-400 text-white"
                      : "bg-white text-gray-800"
                  }`}
                  onClick={() => handleStartEditMode(valueSchema.key)}
                >
                  <FiEdit></FiEdit>
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default ConfigValueControl;
